import { getParkingType } from 'store/selectors/selectors';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { IMMEDIATE_FEATURES } from 'utils/experiment';
import { useFeatureVariation } from 'plugins/optimizely/hooks/use-feature-variation';
function isParkingTypeIncludedInRevamp(parkingType) {
    const isMatchingParkingType = parkingType === 'transient' ||
        parkingType === 'monthly' ||
        parkingType === 'event' ||
        parkingType === 'power_booking' ||
        parkingType === 'airport';
    return isMatchingParkingType;
}
export const useShowNewSearchHeader = () => {
    const { pathname } = useLocation();
    const parkingType = useSelector(getParkingType);
    const isAirport = parkingType === 'airport';
    const isMatchingParkingType = isParkingTypeIncludedInRevamp(parkingType);
    const showLatestDesignForAirport = useFeatureVariation(IMMEDIATE_FEATURES.AIRPORT_UNIFIED_DESIGN_UPDATE) === 'on';
    return (isMatchingParkingType &&
        (pathname === '/search' || pathname === '/search-decoupled') &&
        (isAirport ? showLatestDesignForAirport : true));
};
